import type { FeeWithdrawal, FeeWithdrawalsPagination } from 'src/interfaces/feeWithdrawal'
import type { State } from '../reducers/types'

export const getFeeWithdrawals = (state: State): FeeWithdrawal[] => {
  return state.feeWithdrawals.withdrawals
}

export const getFeeWithdrawalsPagination = (state: State): FeeWithdrawalsPagination => {
  return state.feeWithdrawals.pagination
}

export const getFeeWithdrawalsLoading = (state: State): boolean => {
  return state.feeWithdrawals.loading
}

export const getFeeWithdrawalsError = (state: State): string | null => {
  return state.feeWithdrawals.error
}

export const getFeeWithdrawalReportLoadingIds = (state: State): Record<string, true> => {
  return state.feeWithdrawals.reportLoadingIds
}
